import React from 'react';
import { Intent, Spinner, SpinnerSize } from '@blueprintjs/core';
import { SpinnerContainer, MessageContainer, Message } from './styles';

interface LoadingProps {
  message?: string;
  whiteText?: boolean;
}

const Loading = ({ message, whiteText }: LoadingProps) => {
  return (
    <SpinnerContainer>
      <Spinner intent={Intent.PRIMARY} size={SpinnerSize.LARGE} />
      {message && (
        <MessageContainer>
          <Message $whiteText={whiteText}>{message}</Message>
        </MessageContainer>
      )}
    </SpinnerContainer>
  );
};

export default Loading;
